import React, { useEffect, useState } from 'react'
import Box from '../../../../../../Global/Box'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { toastSweetAlert } from '../../../../../../Helpers/ToastSweetAlert'
import * as Yup from 'yup'
import InputController from '../../../../../../Global/InputController'
import { useLoading } from '../../../../../../../LoadingOverlay/LoadingOverlayContext'
import { useMutation, useQuery } from '@apollo/client'
import {
  GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT,
  GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT_3,
} from '../../../../../../../graphql/Catalog/Groups/groupsCategories'
import { GET_ALL_GROUPS_CATEGORIES_SUBS_BY_CATEGORY_ID } from '../../../../../../../graphql/Catalog/Groups/groupsCategoriesSubs'
import Location from '../../../../ReportWeb/components/Location/Location'
import { GET_ALL_GROUPS } from '../../../../../../../graphql/Catalog/Groups/groups'

const Step1 = ({
  report,
  setReport = () => {},
  refWizard,
  setIsFinish = () => {},
  setIsValidSteps = () => {},
}) => {
  // ------------- Hooks -----------
  const { showLoading, hideLoading } = useLoading()

  const [groups, setGroups] = useState({
    group_id: null,
    group_category_id: null,
    group_category_sub_id: null,
    groups: [],
    categories: [],
    subCategories: [],
  })
  const [dataAddress, setDataAddress] = useState(null)
  // const [markerPosition, setMarkerPosition] = useState(null)
  // const [location, setLocation] = useState(null)
  // const [addressPlacesFull, setAddressPlacesFull] = useState('')

  // ------------- Schema -----------
  const validationSchema = Yup.object().shape({
    group_id: Yup.string().required('Campo requerido'),
    group_category_id: Yup.string().required('Campo requerido'),
    group_category_sub_id: Yup.string().required('Campo requerido'),
    address_full: Yup.string().required('Campo requerido'),
    address_reference: Yup.string(),
  })
  const methods = useForm({ resolver: yupResolver(validationSchema) })
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    watch,
    setValue,
    getValues,
  } = methods
  // ------------- Queries -----------

  const {
    data: dataGroups,
    loading: loadingGroups,
    error: errorGroups,
  } = useQuery(GET_ALL_GROUPS, { fetchPolicy: 'no-cache' })

  const {
    data: dataSubGroups,
    loading: loadingSubGroups,
    error: errorSubGroups,
  } = useQuery(GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT_3, {
    variables: {
      groupId: +groups.group_id,
    },
    fetchPolicy: 'no-cache',
    skip: !groups.group_id,
  })

  // ------------- Mutations -----------
  const [GetGroupsCategoriesSubs] = useMutation(
    GET_ALL_GROUPS_CATEGORIES_SUBS_BY_CATEGORY_ID
  )

  // ------------- UseEffect -----------
  useEffect(() => {
    if (report) {
      /* console.log({
        report,
      }) */
      setGroups((old) => ({
        ...old,
        group_id: report.group_id,
        group_category_id: report.group_category_id,
        group_category_sub_id: report.group_category_sub_id,
      }))
      handleChangeCategory({ value: report.group_category_id })
      reset({
        group_id: report.group_id || null,
        group_category_id: report.group_category_id || null,
        group_category_sub_id: report.group_category_sub_id || null,
        address_full:
          report?.address_components.address_full ||
          report?.address_components.street,
        address_reference: report?.address_components.reference || '',
      })

      if (
        report?.address_components?.latitude &&
        report?.address_components?.longitude
      ) {
        const address = report?.address_components

        // dataEdit = {
        // },

        setDataAddress({
          edit: true,
          full_address: address?.address_full || address?.street,
          address_components: {
            street: address?.street !== '' ? address?.street : ' ',
            colony: address?.colony !== '' ? address?.colony : ' ',
            state: address?.state !== '' ? address?.state : 'Jalisco',
            city: address?.city || null,
            country: address?.country || 'México',
            postalCode: address?.postalCode || null,
          },
          markerPosition: {
            lat: parseFloat(address?.latitude) || null,
            lng: parseFloat(address?.longitude) || null,
          },
          url: address?.url || null,
          zoneIndex: address?.zone_id || null,
          zone_id: address?.zone_id || null,
          // zone_name: null,
          colony_number: address?.colony_number || null,
          colony_name: address?.colony_name || null,
        })
      }
    }
  }, [report])

  useEffect(() => {
    try {
      if (loadingGroups) return
      if (errorGroups) {
        return toastSweetAlert({ mode: 'error', message: errorGroups.message })
      }

      const listOptions = dataGroups.getAllGroups.map((group) => {
        return {
          label: group.name,
          value: group.id,
        }
      })

      setGroups((old) => ({
        ...old,
        groups: listOptions || [],
      }))
    } catch (error) {
      return toastSweetAlert({ mode: 'error', message: error.message })
    }
  }, [dataGroups, loadingGroups, errorGroups])

  useEffect(() => {
    if (!loadingSubGroups) {
      const list =
        dataSubGroups?.getAllGroupsCategoriesAndSubsByGroupIdQuery.map(
          (group) => {
            return { label: group.name, value: group.id }
          }
        )
      setGroups((old) => ({
        ...old,
        categories: list || [],
      }))
    }
  }, [dataSubGroups, loadingSubGroups, errorSubGroups])

  // ------------- Functions -----------
  const onSubmit = async (data) => {
    try {
      const { markerPosition, address_components, full_address } = dataAddress

      if (!markerPosition) {
        return toastSweetAlert({
          mode: 'error',
          message:
            'Debes de seleccionar una ubicación o una direccion en el mapa',
        })
      }

      const { address_reference } = data

      if (!address_components.postalCode)
        return toastSweetAlert({
          mode: 'error',
          message: 'La ubicación debe tener un código postal',
        })

      if (!address_components.street)
        return toastSweetAlert({
          mode: 'error',
          message: 'La ubicación debe tener una calle',
        })

      if (!full_address)
        return toastSweetAlert({
          mode: 'error',
          message: 'La ubicación debe tener una dirección completa',
        })

      setReport({
        ...report,
        step1: {
          ...report.step1,
          group_id: groups.group_id,
          group_category_id: groups.group_category_id,
          group_category_sub_id: groups.group_category_sub_id,
          address_components: {
            address_full: full_address,
            street: address_components.street,
            colony: address_components.colony,
            zipcode: parseInt(address_components.postalCode) || null,
            state: address_components.state,
            city: address_components.city,
            country: address_components.country,
            latitude: markerPosition.lat,
            longitude: markerPosition.lng,
            url: dataAddress.url,
            reference: address_reference,
            zone_id: dataAddress?.zone_id,
            colony_name: dataAddress?.colony_name,
            colony_number: dataAddress?.colony_number,
          },
        },
      })
      reset()
      setIsValidSteps((old) => ({ ...old, step1: true }))
      refWizard.current?.nextTab()
      setIsFinish(true)
      return
    } catch (error) {
      return toastSweetAlert({ mode: 'error', message: error.message })
    }
  }

  const handleChangeCategory = async (selected) => {
    showLoading()
    try {
      if (!selected) {
        setGroups((old) => ({
          ...old,
          group_category_id: '',
          group_category_sub_id: '',
          subCategories: [],
        }))
        setValue('group_category_id', '')
        setValue('group_category_sub_id', '')
        return
      }
      const { value } = selected

      const { data } = await GetGroupsCategoriesSubs({
        variables: { getAllGroupsCategoriesSubByCategoryIdId: value },
      })

      let groupCategorySubs = data?.getAllGroupsCategoriesSubByCategoryId?.map(
        (item) => {
          return { value: item.id, label: item.name }
        }
      )

      setGroups((old) => ({
        ...old,
        group_category_id: value,
        subCategories: groupCategorySubs || [],
      }))
    } catch (error) {
      return toastSweetAlert({ mode: 'error', message: error.message })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <FormProvider {...methods}>
        <form className="px-2 pb-3" onSubmit={handleSubmit(onSubmit)}>
          <Box
            btnSubmit={true}
            // btnState={loadingReport}
            errors={errors}
            withCard={false}
            content={
              <>
                <div className="row">
                  <div className="mb-3 col-12 col-sm-12 col-md-12">
                    <InputController
                      label="Grupo"
                      type="text"
                      name="group_id"
                      inputType="choosen"
                      options={groups?.groups}
                      control={control}
                      changeAction={(e) => {
                        setGroups((old) => ({
                          ...old,
                          group_id: e?.value | null,
                        }))
                        setValue('group_category_id', '')
                        setValue('group_category_sub_id', '')
                        setGroups((old) => ({
                          ...old,
                          group_id: e?.value | null,
                          group_category_id: '',
                          group_category_sub_id: '',
                          categories: [],
                          subCategories: [],
                        }))
                      }}
                      valueManual={groups.group_id}
                      placeholder="Elige"
                      noOptionsMessage={() => 'Sin resultado'}
                      isClearable
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-12 col-md-6">
                    <InputController
                      label="Categoría"
                      type="text"
                      name="group_category_id"
                      inputType="choosen"
                      options={groups?.categories}
                      control={control}
                      changeAction={(e) => {
                        handleChangeCategory(e)
                        setValue('group_category_sub_id', '')
                        setGroups((old) => ({
                          ...old,
                          group_category_sub_id: '',
                        }))
                      }}
                      valueManual={groups.group_category_id}
                      placeholder="Elige"
                      noOptionsMessage={() => 'Sin resultado'}
                      isClearable
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-12 col-md-6">
                    <InputController
                      label="Subcategoría"
                      type="text"
                      name="group_category_sub_id"
                      inputType="choosen"
                      options={groups.subCategories}
                      control={control}
                      valueManual={groups.group_category_sub_id}
                      changeAction={(e) =>
                        setGroups((old) => ({
                          ...old,
                          group_category_sub_id: e?.value | null,
                        }))
                      }
                      placeholder="Elige"
                      noOptionsMessage={() => 'Sin resultado'}
                      isClearable
                      isDisabled={!groups.subCategories}
                    />
                  </div>

                  <Location
                    dataAddress={dataAddress}
                    setDataAddress={setDataAddress}
                    cols="col-12"
                    control={control}
                    disabled={false}
                  />

                  {/* <Location
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                    markerPosition={markerPosition}
                    setMarkerPosition={setMarkerPosition}
                    setDataAddress={setDataAddress}
                    dataAddress={dataAddress}
                    setLocation={setLocation}
                    // disabled={!groups.selected}
                    cols="col-12"
                    addressFull={
                      dataAddress?.address_full ?? dataAddress?.street
                    }
                    dataAddressPlaces={addressPlacesFull}
                    setDataAddressPlaces={setAddressPlacesFull}
                  /> */}
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default Step1
